<template>
  <div>

    <table>
      <tr v-if="economicData.isPTCore">
        <td></td>
        <td class="subscore"></td>
        <td class="subscore cohort px-1">Cohort</td>
        <td class="subscore cohort px-1">Security<br>percentile<br>in cohort</td>
      </tr>
      <tr class="mainRow">
        <td>
          Prepayment Relative Risk Score
          <div class="text-subtitle-2 text--secondary">(Z-Score over Active Loans at Factor Date)</div>
        </td>
        <td v-text="parseFloat(economicData['zsc__prepay_relative_risk__universe']).toFixed(1)"></td>
        <td class="subscore cohort" v-if="economicData.isPTCore" v-text="Number.parseFloat(economicData[`cohort_zsc__prepay_relative_risk__universe`]).toFixed(1)"></td>
        <td class="subscore cohort" v-if="economicData.isPTCore" v-text="Number.parseFloat(economicData[`pctile_in_cohort_zsc__prepay_relative_risk__universe`]).toFixed(1)"></td>
        
      </tr>
      <tr>
        <td colspan="2">
          <h3>
            Percent Change in Baseline Prepayment Odds
          </h3>
        </td>
      </tr>
      
      <tr v-for="variable in Object.keys(dd['pct_change_odds'])">
        <td class="indent">
          {{dd['pct_change_odds'][variable]}}
        </td> 
        <td style="text-align:right;" v-html="parseFloat(economicData[variable]).toFixed(1)"></td>
        <td class="subscore cohort" v-if="economicData.isPTCore" v-text="Number.parseFloat(economicData[`cohort_${variable}`]).toFixed(1)"></td>
        <td class="subscore cohort" v-if="economicData.isPTCore" v-text="Number.parseFloat(economicData[`pctile_in_cohort_${variable}`]).toFixed(1)"></td>
        
      </tr>
      <tr>
        <td colspan="2">
          <h3>
            Localized Affordability
          </h3>
        </td>
      </tr>
      <tr>
        <td class="indent">
          P/I Loan Payment (Z-Score; High = Less Affordable)
        </td>
        <td  style="text-align:right;" v-html="parseFloat(economicData['zsc__loanpayment_affordability']).toFixed(1)"></td>
        <td class="subscore cohort" v-if="economicData.isPTCore" v-text="Number.parseFloat(economicData[`cohort_zsc__loanpayment_affordability`]).toFixed(1)"></td>
        <td class="subscore cohort" v-if="economicData.isPTCore" v-text="Number.parseFloat(economicData[`pctile_in_cohort_zsc__loanpayment_affordability`]).toFixed(1)"></td>        
      </tr>
      <tr>
        <td class="indent">
          Housing Market (Z-Score; High = Less Affordable)
        </td>
        <td  style="text-align:right;" v-html="parseFloat(economicData['zsc__housing_affordability']).toFixed(1)"></td>
        <td class="subscore cohort" v-if="economicData.isPTCore" v-text="Number.parseFloat(economicData[`cohort_zsc__housing_affordability`]).toFixed(1)"></td>
        <td class="subscore cohort" v-if="economicData.isPTCore" v-text="Number.parseFloat(economicData[`pctile_in_cohort_zsc__housing_affordability`]).toFixed(1)"></td>

      </tr>
      <!--
      <tr>
        <td colspan="2">
          <h3>Fair Market Value Spreads</h3>
          <span class="text--secondary">Accumulated Sum (Basis Points) of Period Preceding Factor Date</span>
        </td>
      </tr>
      <tr>
        <td class="indent">
          1-3 Months
        </td>
        <td style="text-align:right;" v-html="parseFloat(economicData['rategap_accumbps_lag_1to3']).toFixed(1)"></td>
      </tr>

      <tr>
        <td class="indent">
          1-6 Months
        </td>
        <td style="text-align:right;" v-html="parseFloat(economicData['rategap_accumbps_lag_1to6']).toFixed(1)"></td>
      </tr>

      <tr>
        <td class="indent">
          1-12 Months 
        </td>
        <td style="text-align:right;" v-html="parseFloat(economicData['rategap_accumbps_lag_1to12']).toFixed(1)"></td>
      </tr>

      <tr>
        <td class="indent">
          1-24 Months
        </td>
        <td style="text-align:right;" v-html="parseFloat(economicData['rategap_accumbps_lag_1to24']).toFixed(1)"></td>
      </tr>
      -->

    </table>
<!--
    <h3>HPA Ratio: Origination Implied Home Value over Median Home Value </h3>
    <table>
      <tr>
        <td></td>
        <td v-for="period in periods">
          {{period}}-Month Lag
        </td>
        <td>Current</td>
      </tr>
      <tr v-for="dimension in ['space','time']">
        <td><strong>Comps Closer in {{dimension}}</strong></td>
        <td v-for="period in periods">
          {{economicData[`hpa_lag_ratio__lag${period}__q50__implied_home_value__${dimension}`]}}
        </td>
        <td>
          {{economicData[`hpa_lag_ratio__current__q50__implied_home_value__${dimension}`]}}
        </td>
      </tr>

    </table>
  -->
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data: () => ({
    savedCollection: null,
    periods: ['60','36','24','12'],
    dd: {
      pct_change_odds: {
        pct_change_odds__loan_factors: "Combined Loan-Level Factors",
        pct_change_odds__context_factors: "Combined Contextual Factors",
      }, 
      hidden_pct_change_odds: {
        pct_change_odds__loan_pct_upb_remaining: "Percent UPB Remaining (Current UPB / Original Loan Amount)", 
        pct_change_odds__margef__affluence__pc1: "Affluence Index", 
        pct_change_odds__margef__age__pc1: "High Concentration of Seniors Index", 
        pct_change_odds__margef__fmv_PC1: "Absolute Loan Overpricing ", 
        pct_change_odds__margef__fmv_PC2: "Borrower Insensitivity to Long-Duration Loan Overpricing", 
        pct_change_odds__margef__ratio_loanpmt_medmonhouscost: "Localized P/I Loan Payment Affordability", 
        pct_change_odds__margef__zsc_diff_hpa_bnd3: "Implied Relative Home Price Appreciation Since Origination", 
        pct_change_odds__margef_fmv_acceleration: "Index of Accelerating Overpricing"
      },
    }

  }),
  props: {
    economicData: Object
  },
  computed: {
    ...mapState({
      results: state => state.currentCusipData,
      labels: state => state.labels
    })
  }

}
</script>
<style scoped>
td.indent {
  padding: 0em 0em 0em 2em;
}
h3 {
  font-size: 1em;
}
</style>